<!-- eslint-disable vue/no-v-html -->
<template>
	<modal-dialog
		v-model:opened="isDialogOpenend"
		size="medium"
		:title="`${t('Zpráva o aktualizaci')} - ${props.releaseNote.name}`"
	>
		<modal-dialog-content>
			<article class="px-4">
				<prose>
					<div v-html="props.releaseNote.releaseNotes" />
				</prose>
			</article>
			<template #footer>
				<div class="flex items-center justify-between gap-24 md:flex-col-reverse md:gap-8">
					<labeled-checkbox
						v-if="!props.preview"
						v-model="releaseNoteConsent"
						check-variant="rectangle"
						:label="t('Chci pravidelně dostávat zprávy o aktualizacích a nových funkcích formou tohoto dialogu.')"
					/>
					<div class="ml-auto w-1/4 md:w-full">
						<settings-button
							size="medium"
							full-width
							@click="handleCloseReleaseNoteDialog"
						>
							{{ t('Dokončit čtení') }}
						</settings-button>
					</div>
				</div>
			</template>
		</modal-dialog-content>
	</modal-dialog>
</template>

<script setup lang="ts">
import { ReleaseNote } from '~/api';

type Props = {
	opened: boolean;
	releaseNote: ReleaseNote;
	releaseNoteConsent?: boolean;
	preview?: boolean;
};

const props = defineProps<Props>();

const { t } = useTranslation();

const emit = defineEmits<{
	'update:opened': [ value: boolean ];
	'update:releaseNoteConsent': [ value: boolean ];
}>();

const releaseNoteConsent = computed({
	get: () => props.releaseNoteConsent,
	set: (value) => emit('update:releaseNoteConsent', value),
});

const isDialogOpenend = computed({
	get: () => props.opened,
	set: (value) => emit('update:opened', value),
});

function handleCloseReleaseNoteDialog () {
	isDialogOpenend.value = false;
}
</script>
